import I18n from "i18n-js";
import React from "react";
import { func, shape } from "prop-types";
import { connect } from "react-redux";
import { ROUTE_SCALES } from "../../../routes";
import {
  updateScale,
  getScaleInfos,
} from "../actions/scalesActions";
import FormPage from "../../common/components/layout/FormPage";
import CreateScaleForm from "../components/CreateScaleForm";

class UpdateScale extends FormPage {
  static propTypes = {
    scale: shape().isRequired,
    match: shape().isRequired,
    getScaleInfos: func.isRequired,
    updateScale: func.isRequired,
  };

  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);
  }

  /**
   * {@inheritdoc}
   */
  componentDidMount() {
    const { getScaleInfos, match } = this.props;

    getScaleInfos(match.params.uuid);
  }

  /**
   * @param {object} scale
   */
  onSubmit(scale) {
    const { updateScale, match } = this.props;

    updateScale(match.params.uuid, scale);
  }

  /**
   * {@inheritdoc}
   */
  getTitle() {
    return I18n.t("pages.scales.update.title");
  }

  /**
   * {@inheritdoc}
   */
  getBackRoute() {
    return ROUTE_SCALES;
  }

  /**
   * {@inheritdoc}
   */
  renderContent() {
    const { scale } = this.props;

    return (
      <CreateScaleForm
        loading={scale.saving}
        infos={scale.infos}
        onSubmit={this.onSubmit}
      />
    );
  }

  /**
   * {@inheritdoc}
   */
  render() {
    const { scale } = this.props;

    if (scale.infos === undefined) {
      return <div className="loader" />;
    }

    if (scale.infos === null) {
      return <p>{I18n.t("pages.scale.update.unknown")}</p>;
    }

    return super.render();
  }
}

const mapStateToProps = (state) => ({
  scale: state.scale,
});

const mapDispatchToProps = (dispatch) => ({
  getScaleInfos: (uuid) => dispatch(getScaleInfos(uuid)),
  updateScale: (uuid, scale) =>
    dispatch(updateScale(uuid, scale)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateScale);
